export default function HeroSkeleton() {
  return (
    <div className='animate-pulse absolute inset-0 bg-gradient-to-br from-gray-200 to-gray-300 z-10 overflow-hidden'>
      <div className='absolute inset-0 -translate-x-full animate-[shimmer_2.5s_infinite] bg-gradient-to-r from-transparent via-white/20 to-transparent' />
    </div>
  );
}
